import { Container } from 'react-bootstrap';
import Header from 'src/components/page/Header';
import Footer from 'src/components/layout/Footer';
import CollapsibleAlert from 'src/components/CollapsibleAlert';
import { Box } from '@mui/material';
import { useContext } from 'react';
import AuthContext from 'src/store/auth-context';
import { useHistory } from 'react-router-dom';

/**
 * A higher-order component that wraps a page with a header, footer, and loading indicator.
 * This component consumes context from the `LoadContext` to show a loading indicator when the context value of `loaded` is `false`. It also consumes context from the `AuthContext` to show an alert if the user is logged in as an admin.
 *
 * @param {Object} props - The props for the component.
 * @param {React.ReactNode} props.children - The content to be rendered inside the container.
 *
 * @returns {React.ReactElement} A React element representing the logged in page.
 */
const LoggedInPage = ({ children }) => {
  const { backdoor, logout } = useContext(AuthContext);
  const history = useHistory();

  const handleLogout = () => {
    if (backdoor) {
      history.push('/admin/home');
    } else {
      logout();
    }
  };

  return (
    <>
      <Header onLogout={handleLogout} />
      <CollapsibleAlert collapse={!backdoor}>
        You are currently logged in as an admin. Any changes you make will not be saved.
      </CollapsibleAlert>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginY: '1.5em',
        }}
      >
        <Container>{children}</Container>
      </Box>
      <Footer />
    </>
  );
};

export default LoggedInPage;
